require('/ui/components/picker/picker.module.scss.module.css');

export const cartSmallFont = "_cart-small-font_1v99q_1";
export const smallViewportSupport = "_small-viewport-support_1v99q_1";
